import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DwComponent, DwComponentType, DwExpressionService, DwFormContextMode, DwFormActionInterceptor, 
         DwMetaDataFormApi, DwMetaDataFormStateService, DwMetaDataService, DwMetaDataServiceToken, 
         DwSectionBaseComponent, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken,
         DwActionPreference, DwFormActionConfig, DwFormActionInterceptResult, DwFormActionKeys,
         DwEventService, DwConfigServiceToken, DwOrmDataService, DwConfigService, 
         DwUser} from '@devwareapps/devware-cap';
import { debounceTime } from 'rxjs/operators';
import { AppMetaDataItemNames, AppMetaDataLookups, FlightSchoolEntity, RoSchoolPaymentMethodEntity,
         PaymentMethodEntity, 
         RoStudentPaymentMethodEntity} 
   from '../../../../meta-data/app-meta-data.service';
import { AppPermissions } from 'src/app/meta-data/app-permissions.enum';
import { Observable, of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { PaymentsRepositoryService } from "src/app/features/payments/services/payments-repository.service";
import { BillingDetailsStudentContext } from '../../models/billings-details-student.model';
import { map, mergeMap } from 'rxjs/operators';
import { AddPaymentEvents } from 'src/app/features/payments/components/add-payment/payments-add-payment.component';

@DwComponent({
    name: 'Student Billing Details UX Util',
    key: 'billingStudentUxUtil',
    componentType: DwComponentType.formSection,
    isGlobal: false,
    parentItemName: AppMetaDataItemNames.DwUser,
})
@Component({
    selector: 'app-billing-student-ux-util',
    template: ` `
})
export class StudentBillingDetailsUtilComponent extends DwSectionBaseComponent implements OnDestroy {
    formApi: DwMetaDataFormApi;
    originalPms: PaymentMethodEntity[] = [];
    paymentsApi: string;
    defaultCard: number;

    constructor(
        dwExpressionService: DwExpressionService,
        private http: HttpClient,
        protected dwUiConfigRegistryService: DwUiConfigRegistryService,
        @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
        @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
        private paymentsRepoSvc: PaymentsRepositoryService,
        private dwFormStateService: DwMetaDataFormStateService,
        private dwEventService: DwEventService,
        @Inject(DwConfigServiceToken) private configService: DwConfigService
    ) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.formApi = this.dwFormStateService.state.formApi;
        this.paymentsApi = `${configService.coreConfig.apiRoot}/aviator-online/Payments`;
    }
    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        for (let subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    
    setupComponentComplete() {
        this.runAfterFormDataLoaded(() => this.setupSubscriptions());
        this.dwFormStateService.addActionInterceptor(this.getFormActionInterceptor());
    }
    updateOriginals() : Observable<PaymentMethodEntity[]>{
        return this.paymentsRepoSvc.getPaymentMethods(false)
            .pipe(mergeMap(pms => {
                this.originalPms = pms;
                return of(this.originalPms);
            }))
    }
    private setupSubscriptions() {
        const user = this.formApi.getFormData<DwUser>();
        this.handleUpdate(user);
        this.updateOriginals().subscribe();

        this.subscriptions.push(
            this.formApi.getFormDataChanges<DwUser>(200)
                .subscribe(user => this.handleUpdate(user)));

        this.subscriptions.push(
                    this.dwEventService
                        .getEventData<any>(AddPaymentEvents.AddStudentPayment)
                        .subscribe(ro => this.updatePayments(ro))
                  );
    }

    updatePayments(ro: any = undefined){
        this.updateOriginals().subscribe(pms => {
            const user = this.formApi.getFormData<DwUser>();
            const ros = (user as any).RoStudentPaymentMethod;

            this.formApi.resetForm(); 

            if (ro != undefined)
                ros.push(ro);

            let updates = { RoStudentPaymentMethod : ros }
            this.formApi.patchFormData(updates);
        });
    }
    getFormActionInterceptor(): DwFormActionInterceptor {
        const interceptor: DwFormActionInterceptor = {
          interceptorName: 'billing-details-student-card-only-interceptor',
          onBeforeAction: (actionPref: DwActionPreference<DwFormActionConfig>, actionConfig: any) => {
            const saveNicknames = actionPref.actionKey == DwFormActionKeys.formSave 
                                && actionPref.actionDisplay.includes("Nick");
            if (saveNicknames){
                //const user = this.formApi.getFormData<DwUser>();
                
                this.originalPms.forEach(p => {
                    const card = this.getCurrentRoPayment(p.PaymentMethodId);
                    p.DisplayName = card.DisplayName;
                });
                
                this.paymentsRepoSvc.savePaymentMethods(this.originalPms)
                    .subscribe(r => {
                        this.updatePayments();
                        this.formApi.patchVariableContext<BillingDetailsStudentContext>({ CardChange: false });
                    });
            }
            const result: DwFormActionInterceptResult = { abort: saveNicknames }
            return of(result);
          }
        }
        return interceptor;
    }
    getCurrentRoPayment(paymentMethodId: number, cards : RoStudentPaymentMethodEntity[] = undefined) 
        : RoStudentPaymentMethodEntity {
        cards = cards ?? this.getRoStudentPaymentMethod();
        return cards.find(c => c.PaymentMethodId == paymentMethodId);
    }

    getRoStudentPaymentMethod() : RoStudentPaymentMethodEntity[]{
        const user: any = this.formApi.getFormData<DwUser>() as any;
        const cards = user.RoStudentPaymentMethod;
        return cards;
    }
    handleUpdate(user: DwUser) {
        const cards = this.getRoStudentPaymentMethod();
        if (cards.length > 0 && this.originalPms.length > 0){
            const deleted = this.originalPms
                                .filter(o => cards.find(c => c.PaymentMethodId == o.PaymentMethodId) == null);
            if (deleted.length > 0)
                deleted.forEach(p => this.paymentsRepoSvc.deletePaymentMethod(p).subscribe());
        }

        const isDef = cards.filter(p => p.IsDefault == true);
        if (this.defaultCard > 0 && isDef.length > 1)
            isDef.find(p => p.PaymentMethodId == this.defaultCard).IsDefault = false;
        
        this.defaultCard = cards.find(p => p.IsDefault == true)?.PaymentMethodId;
        const cardChanges = this.originalPms.filter(rp => 
        {
            const card = this.getCurrentRoPayment(rp.PaymentMethodId, cards);
            return card != undefined && card.DisplayName != rp.DisplayName;
        });
        this.formApi.patchVariableContext<BillingDetailsStudentContext>(
            { CardChange: cardChanges.length > 0 });
    }
}
